import { IInference, IAstNode } from './typings';
import { TypeGenerator, isTypeShallowEquals, isDigit, isNumber, isStringLike, isString } from '../utils/type';
import { InferenceError } from '../errors';


export function inferenceLiteralArray(inference: IInference, astNode: IAstNode) {
  // 数组项不能包含表达式、函数 等
  // if (!!astNode.items.find((node: any) => {
  //   if (node.type !== 'Atom') return true;
  //   if (node.token.isDeclaration &&
  // ['Selector', 'SelectorValue', 'CURRENT_MEMBER_POINT', 'CURRENT_MEMBER_GRADE']
  // .includes(node.token.declaration)) {
  //     return true;
  //   }
  //   return false;
  // })) {
  //   throw new InferenceError('invalid-array-value', '无效的数组值', astNode.token);
  // }

  const itemTypes: any[] = astNode.items.map((item: IAstNode) => inference(item));
  // console.log(itemTypes);

  if (!itemTypes.length) {
    return TypeGenerator.ArrayOf('Unknown', {
      values: []
    });
  }

  // 检查数组的每项值都是相同类型
  for (let index = 1; index < itemTypes.length; index++) {
    const item = itemTypes[index];
    if (!isTypeShallowEquals(item.type, itemTypes[0].type) || item.isArray !== itemTypes[0].isArray) {
      throw new InferenceError('invalid-array-value', '数组中各项值类型不一致', astNode.token);
    }
  }

  const values = astNode.items.map((item: any) => item.token && (
    { ...inference(item), value: item.token.value }
  ));


  // 所有项都为数字
  const isAllDigit = itemTypes.every(item => isDigit(item));
  if (isAllDigit) {
    const hasNumber = itemTypes.some(item => isNumber(item));
    return hasNumber ? TypeGenerator.NumberArray({
      values,
      isLiteralArray: true
    }) : TypeGenerator.IntegerArray({
      values,
      isLiteralArray: true
    });
  }

  // 所有项都为类字符串
  const isAllStringLike = itemTypes.every(item => isStringLike(item));
  if (isAllStringLike) {
    const hasString = itemTypes.some(item => isString(item));
    if (hasString) {
      return TypeGenerator.StringArray({ values, isLiteralArray: true });
    }
    const isUnique = itemTypes.reduce((o, next) => {
      const typeString = next.isArray ? next.type + 'Array' : next.type;
      if (!o.includes(typeString)) o.push(typeString);
      return o;
    }, [] as string[]).length === 1;
    return isUnique ?
      TypeGenerator.ArrayOf(itemTypes[0].type, { values, isLiteralArray: true }) :
      TypeGenerator.StringArray({ values, isLiteralArray: true });
  }

  // 数组中各项的类型集合
  const arrayItemTypes = itemTypes.reduce((types, item) => {
    const typeString = item.isArray ? item.type + 'Array' : item.type;
    if (!types.includes(typeString)) types.push(typeString);
    return types;
  }, []);


  if (arrayItemTypes.length > 1) {
    throw new InferenceError('invalid-array-value', '数组中各项值类型不一致', astNode.token);
  }
  return TypeGenerator.ArrayOf(itemTypes[0].type, {
    values, isLiteralArray: true
  });
}
